import { useContext } from "react";

import { NotificationCenterContext } from "./NotificationCenterProvider";

export function useNotifications() {
  const value = useContext(NotificationCenterContext);
  if (!value) {
    throw new Error(
      "useNotifications doit être utilisé dans NotificationCenterProvider."
    );
  }
  return value;
}

export default useNotifications;
